module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/library/modules/_redefine.js
// module id = 45
// module chunks = 0